import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
// Learner layout + pages
import LearnerLayout from "./layouts/LearnerLayout";
import Dashboard from "./routes/learner/Dashboard";
import Courses from "./routes/learner/Courses";
import Profile from "./routes/learner/Profile";
import Team from "./routes/learner/Team";
// Admin layout + pages
import AdminPanel from "./routes/admin/AdminPanel";
import Branding from "./routes/admin/Branding";
import Users from "./routes/admin/Users";
import UserManagement from "./routes/admin/UserManagement";
import Groups from "./routes/admin/Groups";
import GroupManagement from "./routes/admin/GroupManagement";
import CoursesAdmin from "./routes/admin/Courses";
import CourseManagement from "./routes/admin/CourseManagement";
import Reporting from "./routes/admin/Reporting";
import AssignmentRules from "./routes/admin/AssignmentRules";
import EmailSettings from "./routes/admin/EmailSettings";
import Surveys from "./routes/admin/Surveys";
import Notifications from "./routes/admin/Notifications";
import LearningPaths from "./routes/admin/LearningPaths";
import Certificates from "./routes/admin/Certificates";
import LoginSettings from "./routes/admin/LoginSettings";
import TrainingRecords from "./routes/admin/TrainingRecords";
// Auth pages
import Login from "./routes/Login";
import ResetPassword from "./routes/ResetPassword";
// ADDED: protected route
import ProtectedRoute from "./context/ProtectedRoute";

export default function App() {
  return (
    <Routes>
      {/* Root redirect to Login */}
      <Route path="/" element={<Navigate to="/login" replace />} />

      {/* Auth routes — public */}
      <Route path="/login" element={<Login />} />
      <Route path="/reset-password" element={<ResetPassword />} />

      {/* ADDED: all protected routes wrapped in ProtectedRoute */}
      <Route element={<ProtectedRoute />}>
        {/* Learner routes */}
        <Route path="/learner" element={<LearnerLayout />}>
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="courses" element={<Courses />} />
          <Route path="team" element={<Team />} />
          <Route path="profile" element={<Profile />} />
        </Route>

        {/* Admin routes */}
        <Route path="/admin" element={<AdminPanel />}>
          <Route index element={<Navigate to="users" replace />} />
          <Route path="branding" element={<Branding />} />
          <Route path="email" element={<EmailSettings />} />
          <Route path="login-settings" element={<LoginSettings />} />
          <Route path="users" element={<Users />} />
          <Route path="user-management" element={<UserManagement />} />
          <Route path="groups" element={<Groups />} />
          <Route path="group-management" element={<GroupManagement />} />
          <Route path="courses" element={<CoursesAdmin />} />
          <Route path="course-management" element={<CourseManagement />} />
          <Route path="learning-paths" element={<LearningPaths />} />
          <Route path="certificates" element={<Certificates />} />
          <Route path="notifications" element={<Notifications />} />
          <Route path="surveys" element={<Surveys />} />
          <Route path="rules" element={<AssignmentRules />} />
          <Route path="reporting" element={<Reporting />} />
          <Route path="training-records" element={<TrainingRecords />} />
        </Route>
      </Route>

      {/* Catch-all 404 */}
      <Route
        path="*"
        element={<h1 className="p-8 text-2xl">404 – Page Not Found</h1>}
      />
    </Routes>
  );
}
